import { Header } from '@/components/Header';
import { ActionBar } from '@/dashboards/CampaignOptimization/components/ActionBar';
import { useCampaignActions } from '@/dashboards/CampaignOptimization/hooks/useCampaignActions';
import { InlineEditableTextInput } from '@analytical-alley/ui';

export const CampaignOptimisationHeader = () => {
    const { updateCampaignName, campaignName, canSave } = useCampaignActions();

    return (
        <Header
            className="pb-6 px-8 lg:px-16 pt-6"
            title="Campaign Optimization"
            sticky
            tooltip={
                <span>
                    Campaign planner. <br /> Fine-tune your campaign performance
                    for maximum impact. <br />
                    Set your target and simulate different media investment
                    scenarios to find the optimal balance across media channels
                    based on your goal and constraints. <br />
                    Adjust duration of your campaign to see how timing affects
                    results, then refer to the execution roadmap below to
                    implement these changes.
                </span>
            }
            subtitle={
                !!campaignName ? (
                    <InlineEditableTextInput
                        disabled={!canSave}
                        value={campaignName}
                        onAccept={(name) => updateCampaignName(name.trim())}
                    />
                ) : (
                    ''
                )
            }
        >
            <ActionBar />
        </Header>
    );
};
